import reqest from "../common/reqest";

/**
 * 搜索订单
 * @param data
 * @returns {Promise<unknown>}
 */
export function searchOrder(data) {
  return reqest.send("/index/findOrderList", data)
}
export function updateOrderInfo(data) {
  return reqest.send("/index/updateOrderInfo", data)
}

/**
 * 观展购票生成订单
 * @param data
 * @returns {Promise<unknown>}
 */
export function createGzOder(data) {
  return reqest.send("/Order/Order_Create_Gz", data)
}

/**
 * 参展方购票生成订单
 * @param data
 * @returns {Promise<unknown>}
 */
export function createCzOrder(data) {
  return reqest.send("/Order/Order_Create", data)
}

/**
 * 新买票支付接口
 * @param data
 * @returns {Promise<unknown>}
 */
export function ExhibitionOnPay(data) {
  return reqest.send("/Order/Exhibition_on_pay", data)
}
/**
 * 云钱支付
 * @param data
 * @returns {Promise<unknown>}
 */
export function cloudMoneyPay(data) {
  return reqest.send("/Order/cloudMoneyPay", data)
}
/**
 * 云钱充值
 * @param data
 * @returns {Promise<unknown>}
 */
export function cloudRechargePay(data) {
  return reqest.send("/Order/cloudRechargePay", data)
}

/**
 * 前往云钱
 * @param data
 * @returns {Promise<unknown>}
 */
export function goCloudPay(data) {
  return reqest.send("/Login/getAccountCode", data)
}


/**
 * 购票页面展会详情
 * @param data
 * @returns {Promise<unknown>}
 * @constructor
 */
export function exhibitionInfo(data) {
  return reqest.send("/Order/Order_Exhibition", data, true);
}

/**
 * 查询微信支付
 * @param data
 * @returns {Promise<unknown>}
 */
export function wxPay(data) {
  return reqest.send("/Order/Wx_Paystate", data)
}

/**
 * 新支付接口
 */
export function ExhibitionPayInfo(data) {
  return reqest.send("/Wxapplet/Exhibition_Pay_info", data)
}


/**
 * 新增三个展会报名接口
 */
export function FreeOrder(data) {
  return reqest.send("/order/free_order", data)
}


/**
 * 新增三个展会WIFFA会员报名接口
 */
export function WiffaFreeOrder(data) {
  return reqest.send("/order/wiffa_free_order", data)
}
export function getRechargeList(data) {
  return reqest.send("/order/get_recharge_list", data)
}


